import { useState } from 'react';
import styled from 'styled-components';
import { defineMessages, useIntl } from 'react-intl';
import { Button } from '../../shared-components/atomic-components';
import { DateRangePicker } from '../../shared-components/date-range-picker/date-range-picker';

const exportMessages = defineMessages({
  exportDatesButton: {
    id: 'export.export_dates_button',
    defaultMessage: 'Export these dates',
    description: 'Text for export button ',
  },
});

interface ExportByDatesProps {
  initialEndDate: Date;
  initialStartDate: Date;
  loading: boolean;
  maxDate?: Date;
  minDate?: Date;
  onDownload: (startDate: Date | null, endDate: Date | null) => Promise<void>;
}

export const ExportByDates: React.FC<ExportByDatesProps> = ({
  initialEndDate,
  initialStartDate,
  loading,
  maxDate,
  minDate,
  onDownload,
}) => {
  const intl = useIntl();

  const [startDate, setStartDate] = useState<Date | null>(initialStartDate);
  const [endDate, setEndDate] = useState<Date | null>(initialEndDate);

  const isDateValid = startDate !== null && endDate !== null && startDate <= endDate;

  return (
    <S.Container>
      <S.DateRangePicker
        startDate={startDate}
        endDate={endDate}
        onChangeStartDate={setStartDate}
        onChangeEndDate={setEndDate}
        maxDate={maxDate ?? new Date()}
        minDate={minDate}
      />
      <S.Button
        variant="secondary"
        disabled={!isDateValid}
        onClick={() => {
          if (isDateValid) {
            onDownload(startDate, endDate);
          }
        }}
        loading={loading}
      >
        {intl.formatMessage(exportMessages.exportDatesButton)}
      </S.Button>
    </S.Container>
  );
};

const S = {
  Container: styled.div``,
  Button: styled(Button)`
    width: 146px;
    font-size: 10px;
    margin: auto;
    border-radius: 8px;
    margin-top: 12px;
  `,
  ErrorMessage: styled.div`
    margin-top: 10px;
    font-size: 13px;
    color: ${(props) => props.theme.legacy.red};
    text-align: center;
  `,
  DateRangePicker: styled(DateRangePicker)`
    gap: 16px;
  `,
};
